module.exports = __webpack_public_path__ + "img/exclamation-circle-solid-gray.e366b4cc.svg";